import React, { useState, useEffect } from 'react';
import { Alert, Typography, Link, Button, Card, CardBody, } from '@one-thd/sui-atomic-components';
import { stashLinkEvent } from '../../utils/analytics';
import { getConfigurationValue } from '../../utils/general';
import { UPGRADE_TO_PRO_PATH } from '../../constants/links';
import { useModalState } from '../../hooks/use-modal-state';
import styles from './upgrade-to-pro.module.scss';
import { isHomeDepotEmail } from '../../utils/email';
import { useProfile } from '../../hooks/use-profile';
import { ConvertToProModal } from '../modal/convert-to-pro';
import { TAlertStatus } from '../../models/common/alert-messages';
export var UpgradeToPro = function () {
    var _a = useModalState(), modalOpen = _a.modalOpen, openModal = _a.openModal, closeModal = _a.closeModal;
    var _b = useState(false), isConvertToProError = _b[0], showConvertToProError = _b[1];
    var customerData = useProfile().customerData;
    useEffect(function () {
        var params = new URLSearchParams(window.location.search);
        if (params.get('plcc-upgrade-flow') === 'true') {
            openModal();
        }
    }, []);
    var handleConvertToProClick = function () {
        var _a, _b;
        var emailId = (_b = (_a = customerData === null || customerData === void 0 ? void 0 : customerData.response.account) === null || _a === void 0 ? void 0 : _a.profile) === null || _b === void 0 ? void 0 : _b.emailId;
        if (!isHomeDepotEmail(emailId)) {
            openModal();
        }
        else {
            showConvertToProError(true);
        }
        stashLinkEvent('profile page: b2c: convert to proxtra account link');
    };
    var isUpgradeToProEnabled = getConfigurationValue('ENABLE_UPGRADE_TO_PRO') === '1';
    var link = (React.createElement("span", { onClick: function () {
            return stashLinkEvent('profile page: b2c: convert to proxtra account link');
        }, role: "link", tabIndex: 0 },
        React.createElement(Link, { href: UPGRADE_TO_PRO_PATH, target: "_blank", underline: "hover" }, "Pro Xtra Account"),
        ' '));
    return isUpgradeToProEnabled ? (React.createElement(React.Fragment, null,
        modalOpen && React.createElement(ConvertToProModal, { open: modalOpen, onClose: closeModal }),
        React.createElement("div", { className: "sui-max-w-[305px] sui-m-auto" },
            React.createElement(Card, null,
                React.createElement(Typography, { height: "snug", weight: "display", variant: "h3" },
                    React.createElement("span", { className: "sui-text-3xl" }, "Join the Pro Xtra Program")),
                React.createElement(CardBody, null,
                    React.createElement(Typography, { variant: "body-base", weight: "regular" },
                        "Shopping for your business? Convert to a ",
                        link,
                        "to save time, save money, and get rewarded through members-only benefits and business tools.")),
                React.createElement("div", { className: styles.button },
                    React.createElement(Button, { variant: "text", onClick: handleConvertToProClick, underline: "hover", "data-testid": "convert-to-pro-xtra-btn" }, "Convert to Pro Xtra Account")),
                isConvertToProError && (React.createElement(Alert, { status: TAlertStatus.ERROR },
                    React.createElement(Typography, { variant: "body-base" }, "We're sorry, but you can't register as a Pro customer with a homedepot.com email address."))))))) : null;
};
